import request from "@/utils/request";

export function queryCustomerListById(data){
  return request({
    url:'/osp/person/queryCustomerListById',
    method:'post',
    data: data
  })
}

export function queryPersonSaleInfoById(data){
  return request({
    url:'/osp/person/querySaleInfoById',
    method:'post',
    data:data
  })
}
